import React from 'react';
import { Link } from 'react-router-dom';
import './ComingSoon.css';

export default function ComingSoon({
  feature = 'This feature',
  description = 'is coming soon.',
  backTo = '/',
  feedbackHref = null,   // e.g. "mailto:team@acme.com?subject=Notify me"
  icon = '🚧',
  eta = null,            // e.g. "Q4 2025"
  children,
}) {
  return (
    <div className="coming-soon">
      <div className="coming-soon__card">
        <div className="coming-soon__icon" aria-hidden="true">{icon}</div>

        <h1 className="coming-soon__title">
          {feature} <span>is coming soon</span>
        </h1>

        {eta && <div className="coming-soon__eta">ETA: {eta}</div>}

        {description && <p className="coming-soon__desc">{description}</p>}

        {children /* optional extra content */}

        <div className="coming-soon__actions">
          <Link to={backTo} className="coming-soon__btn coming-soon__btn--primary">← Back</Link>
          {feedbackHref && (
            <a
              className="coming-soon__btn coming-soon__btn--ghost"
              href={feedbackHref}
              target={feedbackHref.startsWith('http') ? '_blank' : undefined}
              rel="noreferrer"
            >
              Notify me
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
